import * as dealRecapSelectors from '@makemydeal/dr-dash-store/selectors/dealRecapSelectors';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import { useMediaQuery } from 'react-responsive';
import { Grid } from '@interstate/components/Grid';
import { useDealSummary } from '../../common/DealSummaryProvider';
import DealSummaryItem from '../common/DealSummaryItem';
import { ZERO_DOLLARS } from '../../constants';
import { FrontendProfitSchema, DealRecapSectionsLabels } from '../../common/constants/DealRecap';
import LineItemWithChildren from '../common/LineItemWithChildren';
import { getLabelNodeStyles } from '../utils/transform';
import {
    detailedViewGridProps,
    defaultGridProps,
    primaryValueNodeStyles,
    secondaryValueStyles,
    nestedLabelNodeStyles
} from '../utils/styles';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

const FrontEndProfit = () => {
    const isLargeSize = useMediaQuery({ query: `(min-width: ${BreakPoint.MEDIUM})` });
    const { showDetailedView } = useDealSummary();
    const gridProps = showDetailedView && isLargeSize ? detailedViewGridProps : defaultGridProps;
    const frontendProfitDetails = useTrackedSelector(dealRecapSelectors.getFrontendProfitDetails, {
        component: 'FrontEndProfit',
        field: 'frontendProfitDetails'
    });
    return (
        <DealSummaryItem
            valueStyles={primaryValueNodeStyles}
            labelStyles={getLabelNodeStyles(showDetailedView, true)}
            label={DealRecapSectionsLabels.FRONTEND_PROFIT}
            value={formatDollarsAndCents(frontendProfitDetails.frontEndProfit, ZERO_DOLLARS)}
        >
            <Grid container sx={gridProps}>
                {FrontendProfitSchema.map((item, index) => (
                    <LineItemWithChildren
                        key={`${item.label}-${index}`}
                        containerStyles={{
                            paddingTop: '8px',
                            paddingBottom: '8px'
                        }}
                        valueStyles={secondaryValueStyles}
                        labelStyles={nestedLabelNodeStyles}
                        label={String(item.label)}
                        value={formatDollarsAndCents(
                            frontendProfitDetails[item.value as keyof typeof frontendProfitDetails],
                            item.value === 'vehicleCost' ? undefined : ZERO_DOLLARS
                        )}
                    />
                ))}
            </Grid>
        </DealSummaryItem>
    );
};

export default FrontEndProfit;
